/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/api/axiosInstance.js";
import type { FindUserDetailsQueryResponse, FindUserDetails400, FindUserDetails401, FindUserDetails404, FindUserDetails409, FindUserDetails500 } from "../../types/FindUserDetails.js";
import type { Client, RequestConfig, ResponseErrorConfig } from "@/api/axiosInstance.js";

function getFindUserDetailsUrl() {
  const res = { method: 'GET', url: `/api/me` as const }
  return res
}

/**
 * @description Retrieves the details of the currently authenticated user.
 * @summary Get user details
 * {@link /api/me}
 */
export async function findUserDetails(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<FindUserDetailsQueryResponse, ResponseErrorConfig<FindUserDetails400 | FindUserDetails401 | FindUserDetails404 | FindUserDetails409 | FindUserDetails500>, unknown>({ method : "GET", url : getFindUserDetailsUrl().url.toString(), ... requestConfig })
  return res.data
}